const LINEAR_CHANNELS_STATE_STATUSES = {
  EMPTY: 'EMPTY',
  PENDING: 'PENDING',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

export { LINEAR_CHANNELS_STATE_STATUSES };
